import { Component, inject, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { MenuComponent } from '../menu/menu.component';
import { ModeConfiguration } from './header-configuration';
import { MatToolbar } from '@angular/material/toolbar';
import { buildUrl } from '../../utils/urlUtils';
import { MatIcon } from '@angular/material/icon';
import { EnvironementService } from '../../services/environement.service';
import { ModeService } from '../../services/mode.service';
import { ChipEnvironementComponent } from '../chip-environement/chip-environement.component';

/**
 * Header de Pegase, fait pour etre utilise conjointement avec PegaseMenuComponent
 * !! Si les inputs title et icon ne sont pas definis, l'app ne compilera pas !!
 * usage:
 * ```
 * <pegase-header title="Controler le cursus" icon="school">
 *    <lib-authentication-form></lib-authentication-form>
 * </pegase-header>
 * ```
 * le composant lib-authentication-form (@pcscol-portail/ng-auth) doit lui etre fourni comme enfant :
 * sans lui, la zone profil reste vide.
 *
 * Le rendu gestionnaire ou apprenant n'est pas un input : il vient de
 * {@link ModeService}, c'est-à-dire de `pegase.mode` dans `assets/config.json`.
 */
@Component({
  selector: 'lib-pegase-header[title][icon]',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [NgClass, MatToolbar, MatIcon, ChipEnvironementComponent],
})
export class HeaderComponent {
  @Input() title!: string;
  @Input() icon!: string;
  /**
   * desactive le lien vers AGE
   */
  @Input() disableAgeLink?: boolean = false;
  /**
   * Masque le logo Pégase : pour les apps dont le menu latéral doit être affiché et affiche déjà le logo.
   */
  @Input() showLogo?: boolean = true;
  public environementService = inject(EnvironementService);
  private modeService = inject(ModeService);
  protected menu = inject(MenuComponent, { optional: true, host: true });

  protected get config(): ModeConfiguration {
    return this.modeService.configuration;
  }

  /**
   * Classe d'environnement et classe de mode réunies : `[ngClass]` ne peut pas
   * cohabiter avec un `[class]` sur le même élément.
   */
  protected get headerClasses(): string[] {
    return [this.getEnvClass(), this.config.headerClass].filter((cssClass): cssClass is string => !!cssClass);
  }

  get isMenuOpened(): boolean {
    return this.menu?.isNavOpened ?? false;
  }

  linkToAge() {
    return this.disableAgeLink ? null : buildUrl(this.config.ageApp);
  }

  getEnvClass(): string {
    return this.environementService.getEnvClass();
  }

  isValidEnv(): boolean {
    return this.environementService.isValidEnv();
  }
}